/* istanbul ignore file */
/* tslint:disable */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { CreateLTIData, LTI1p1Provider, LTI1p3Provider, LTIProviderBase, Patch1P1ProviderLTIData, Patch1P3ProviderLTIData, PatchProviderLTIData, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function lti(config) {
    const createResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(LTIProviderBase)),
    });
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(LTIProviderBase))),
    });
    const patch1P1ProviderResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(LTI1p1Provider)),
    });
    const get1P3ProviderResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(LTI1p3Provider)),
    });
    const patch1P3ProviderResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(LTI1p3Provider)),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(LTIProviderBase)),
    });
    const getAll1P3Response = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(LTI1p3Provider))),
    });
    const patchProviderResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(LTIProviderBase)),
    });
    return Object.freeze({
        /**
         * Create a new LTI 1.1 or 1.3 provider.
         *
         * This route is part of the public API.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The just created provider.
         */
        create: async ({ requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/lti/providers/`, createResponse.v, JSON.stringify(CreateLTIData.encode(requestBody)));
            return result;
        },
        /**
         * List all known LTI providers for this instance.
         *
         * This route is part of the public API.
         *
         * @returns A list of all known LTI providers.
         */
        getAll: async () => {
            const result = await requestParams(config, 'GET', `/api/v1/lti/providers/`, getAllResponse.v, undefined);
            return result;
        },
        /**
         * Update the given LTI 1.1 provider.
         *
         * This route is part of the public api.
         *
         * @param arg The arguments to the function.
         * @param arg.ltiProviderId The id of the provider you want to update.
         * @param arg.requestBody The body of the request.
         * @param arg.secret The secret to use to update the provider.
         * @returns The updated provider.
         */
        patch1P1Provider: async ({ ltiProviderId, requestBody, secret = undefined, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/lti1.1/providers/${ltiProviderId}`, patch1P1ProviderResponse.v, JSON.stringify(Patch1P1ProviderLTIData.encode(requestBody)), {
                secret,
            });
            return result;
        },
        /**
         * Get a LTI 1.3 provider.
         *
         * This route is part of the public API.
         *
         * @param arg The arguments to the function.
         * @param arg.ltiProviderId The id of the provider you want to get.
         * @returns The requested LTI 1.3 provider.
         */
        get1P3Provider: async ({ ltiProviderId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/lti1.3/providers/${ltiProviderId}`, get1P3ProviderResponse.v, undefined);
            return result;
        },
        /**
         * Update the given LTI 1.3 provider.
         *
         * This route is part of the public API.
         *
         * @param arg The arguments to the function.
         * @param arg.ltiProviderId The id of the provider you want to update.
         * @param arg.requestBody The body of the request.
         * @param arg.secret The secret to use to update the provider.
         * @returns The updated LTI 1.3 provider.
         */
        patch1P3Provider: async ({ ltiProviderId, requestBody, secret = undefined, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/lti1.3/providers/${ltiProviderId}`, patch1P3ProviderResponse.v, JSON.stringify(Patch1P3ProviderLTIData.encode(requestBody)), {
                secret,
            });
            return result;
        },
        /**
         * Get a LTI provider.
         *
         * This route is part of the public API.
         *
         * @param arg The arguments to the function.
         * @param arg.ltiProviderId The id of the provider you want to get.
         * @param arg.secret The secret to use to update the provider.
         * @returns The requested LTI 1.1 or 1.3 provider.
         */
        get: async ({ ltiProviderId, secret = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/lti/providers/${ltiProviderId}`, getResponse.v, undefined, {
                secret,
            });
            return result;
        },
        /**
         * List all known LTI 1.3 providers for this instance.
         *
         * This route is part of the public API.
         *
         * @returns A list of all known LTI 1.3 providers.
         */
        getAll1P3: async () => {
            const result = await requestParams(config, 'GET', `/api/v1/lti1.3/providers/`, getAll1P3Response.v, undefined);
            return result;
        },
        /**
         * Update the given LTI provider.
         *
         * @param arg The arguments to the function.
         * @param arg.ltiProviderId The id of the provider you want to update.
         * @param arg.requestBody The body of the request.
         * @returns The updated LTI provider.
         */
        patchProvider: async ({ ltiProviderId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/lti/providers/${ltiProviderId}/label`, patchProviderResponse.v, JSON.stringify(PatchProviderLTIData.encode(requestBody)));
            return result;
        },
    });
}
